import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { useAppContext } from 'new-components/OpAppScaffold/components/AppContext';
import { getAppOrigin } from 'utils/getAppOrigin';

export const useNavigateToAdmin = (orgId: number) => {
  const { app } = useAppContext();
  const navigate = useNavigate();

  const handleNavigateToAdmin = useCallback(() => {
    if (app === 'admin') {
      navigate(0);
      return;
    }

    window.open(`${getAppOrigin('admin')}/o/${orgId}`, '_self');
  }, [app, navigate, orgId]);

  return {
    handleNavigateToAdmin,
  };
};
